import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top ${
        scrolled ? "scrolled" : ""
      }`}>
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img src="./Images/logo.png" alt="Logo" className="logo" />
        </Link>

        {/* Navbar Toggler for Mobile */}
        <button
          className="navbar-toggler text-dark"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav">
          <ul className="navbar-nav align-items-center">
            <li className="nav-item">
              <a className="nav-link" href="mailto:info@madadvisors.in">
                <i className="fas fa-envelope"></i> info@madadvisors.in
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="tel:+91-0000 000 000">
                <i className="fas fa-phone-alt"></i> +91 8112 259 120
              </a>
            </li>

            {/* Social Icons */}
            <li className="nav-item social-icons">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
